export default {
    getFields(Selector) {
        return {
            "cart_offer_attachment": {
                required: false,
                fileMaxSize: [5 , 'MB'],
                customFileExtension: "pdf"
            }
        }
    }
}export default {
    getFields(Selector) {
        return {
            "cart_offer_attachment": {
                required: false,
                fileMaxSize: [5 , 'MB'],
                customFileExtension: "pdf"
            }
        }
    }
}